import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { postData } from '../../../services/NodeServices';

const AddReview = ({ productId, variantId="", userId, username, onReviewAdded }) => {
  const [formData, setFormData] = useState({
    rating: 0,
    review_text: '',
    username: username || '',
    product_id:''
  });
  const [hoveredRating, setHoveredRating] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear any existing messages when user starts typing
    if (message.text) setMessage({ type: '', text: '' });
  };

  const handleRatingClick = (rating) => {
    setFormData(prev => ({
      ...prev,
      rating
    }));
    // Clear any existing messages when user selects rating
    if (message.text) setMessage({ type: '', text: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.rating || !formData.review_text.trim()) {
      setMessage({ type: 'error', text: 'Please provide both rating and review text.' });
      return;
    }

    // Check if username is required when userId is not provided
    if (!userId && !formData.username.trim()) {
      setMessage({ type: 'error', text: 'Please provide a username.' });
      return;
    }

    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await  postData('api/products/addreview', {
        
    
          product_id: productId||360,
          variant_id: variantId||342,
          userid: userId || 1,
          username: formData.username.trim(),
          rating: formData.rating,
          review_text: formData.review_text.trim()
      
      });

      

      if (response.status) {
        setMessage({ type: 'success' });
        setFormData({ 
          rating: 0, 
          review_text: '', 
          username: username || '' // Reset to original username or empty
        });
        setHoveredRating(0);
        
        // Call callback if provided
        
      } else {
        setMessage({ type: 'error' });
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      setMessage({ type: 'error', text: 'Failed to submit review. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style jsx>{`
        .review-form-container {
          max-width: 600px;
          margin: 0 auto;
          padding: 24px;
          background: #ffffff;
          border-radius: 12px;
        

        }

        .review-form-title {
          font-size: 24px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 8px;
          text-align: center;
        }

        .review-form-subtitle {
          color: #6b7280;
          text-align: center;
          margin-bottom: 32px;
          font-size: 14px;
        }

        .review-form {
          width: 100%;
        }

        .form-group {
          margin-bottom: 24px;
        }

        .form-label {
          display: block;
          font-weight: 600;
          color: #374151;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .rating-container {
          display: flex;
          gap: 4px;
          margin-bottom: 4px;
        }

        .star-button {
          background: none;
          border: none;
          cursor: pointer;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s ease;
        }

        .star-button:hover {
          background: #f3f4f6;
          transform: scale(1.05);
        }

        .star-button:focus {
          outline: 2px solid #3b82f6;
          outline-offset: 2px;
        }

        .star-icon {
          width: 28px;
          height: 28px;
          transition: all 0.2s ease;
        }

        .star-filled {
          color: #fbbf24;
          fill: #fbbf24;
        }

        .star-empty {
          color: #d1d5db;
          fill: none;
        }

        .rating-text {
          font-size: 12px;
          color: #6b7280;
          margin-top: 4px;
        }

        .input-field {
          width: 100%;
          padding: 12px;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 14px;
          font-family: inherit;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .input-field:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .input-field::placeholder {
          color: #9ca3af;
        }
          width: 100%;
          min-height: 120px;
          padding: 12px;
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          font-size: 14px;
          font-family: inherit;
          resize: vertical;
          transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }

        .textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .textarea::placeholder {
          color: #9ca3af;
        }

        .char-count {
          text-align: right;
          font-size: 12px;
          color: #6b7280;
          margin-top: 4px;
        }

        .submit-button {
          width: 100%;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          color: white;
          border: none;
          padding: 14px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        }

        .submit-button:hover:not(:disabled) {
          background: linear-gradient(135deg, #2563eb, #1e40af);
          transform: translateY(-1px);
          box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
        }

        .submit-button:active:not(:disabled) {
          transform: translateY(0);
        }

        .submit-button:disabled {
          background: #9ca3af;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .loading-spinner {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid transparent;
          border-top: 2px solid currentColor;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-right: 8px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .message {
          padding: 12px 16px;
          border-radius: 6px;
          margin-bottom: 16px;
          font-size: 14px;
          font-weight: 500;
        }

        .message-success {
          background: #ecfdf5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        }

        .message-error {
          background: #fef2f2;
          color: #991b1b;
          border: 1px solid #fecaca;
        }

        @media (max-width: 640px) {
          .review-form-container {
            margin: 16px;
            padding: 20px;
          }
          
          .review-form-title {
            font-size: 20px;
          }
          
          .star-icon {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>

      <div className="review-form-container">
        <h2 className="review-form-title">Write a Review</h2>
        <p className="review-form-subtitle">Share your experience with this product</p>

        {message.text && (
          <div className={`message ${message.type === 'success' ? 'message-success' : 'message-error'}`}>
            {message.text}
          </div>
        )}

        <div className="review-form">
          {/* Username field - only show if no userId provided or username is empty */}
          { (
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                Name {!userId ? '*' : ''}
              </label>
              <input
                id="username"
                name="username"
                type="text"
                value={formData.username}
                onChange={handleInputChange}
                placeholder="Enter your name"
                className="input-field"
                maxLength={50}
                disabled={!!username} // Disable if username is provided as prop
              />
            </div>
          )}



           { (
            <div className="form-group">
              <label htmlFor="product_id" className="form-label">
                Product Id {!userId ? '*' : ''}
              </label>
              <input
                id="product_id"
                name="product_id"
                type="text"
                value={formData.product_id}
                onChange={handleInputChange}
                placeholder="Enter Product ID"
                className="input-field"
                maxLength={50}
                disabled={!!productId} 
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Rating *</label>
            <div className="rating-container">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className="star-button"
                  onClick={() => handleRatingClick(star)}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
                >
                  <Star 
                    className={`star-icon ${
                      star <= (hoveredRating || formData.rating) 
                        ? 'star-filled' 
                        : 'star-empty'
                    }`}
                  />
                </button>
              ))}
            </div>
            {formData.rating > 0 && (
              <div className="rating-text">
                {formData.rating === 1 && "Poor"}
                {formData.rating === 2 && "Fair"}
                {formData.rating === 3 && "Good"}
                {formData.rating === 4 && "Very Good"}
                {formData.rating === 5 && "Excellent"}
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="review_text" className="form-label">
              Review *
            </label>
            <textarea
              id="review_text"
              name="review_text"
              value={formData.review_text}
              onChange={handleInputChange}
              placeholder="Share your thoughts about this product..."
              className="textarea"
              maxLength={1000}
            />
            <div className="char-count">
              {formData.review_text.length}/1000 characters
            </div>
          </div>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting}
              className="submit-button"
            >
            {isSubmitting && <span className="loading-spinner"></span>}
            {isSubmitting ? 'Submitting...' : 'Submit Review'}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddReview;